@if (getCard().type === 'htmlCard') {
  <div
    [class]="'message-card-html ' + this.getHtmlCard().data.cssClass"
    >
    <div [innerHTML]="getHtmlCard().data.html"></div>
    @if (this.enableDeletion()) {
      <ng-template
        [ngTemplateOutlet]="delete"
      ></ng-template>
    }
  </div>
}

@if (this.type === 'buttonsCard') {
  <div
    [class]="'message-card-buttons ' + this.buttonCard.data.cssClass"
    >
    @if (this.buttonCard.data) {
      <app-button-card
        [buttons]="this.buttonCard.data.buttons"
        [isLast]="this.isLast()"
      ></app-button-card>
    }
    @if (this.enableDeletion()) {
      <ng-template
        [ngTemplateOutlet]="delete"
      ></ng-template>
    }
  </div>
}

@if (getCard().type === 'youtubeCard') {
  <div
    [class]="'message-card-youtube ' + this.getYoutubeCard().data.cssClass"
    >
    <iframe
      width="auto"
      [src]="('https://www.youtube-nocookie.com/embed/' + this.getYoutubeCard().data.id) | safe"
      title="YouTube video player"
      frameborder="0"
      allow="display-capture;camera;microphone;geolocation; fullscreen;accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
    @if (this.enableDeletion()) {
      <ng-template
        [ngTemplateOutlet]="delete"
      ></ng-template>
    }
  </div>
}

@if (getCard().type === 'iframeCard') {
  <div
    [class]="'message-card-iframe ' + this.getIframeCard().data.cssClass"
    >
    <iframe
      [title]="this.getIframeCard().data.url"
      width="auto"
      [src]="this.getIframeCard().data.url | safe"
      style="border: 1px solid black;"
      allow="display-capture;camera;microphone;geolocation; fullscreen;accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
    ></iframe>
    @if (this.enableDeletion()) {
      <ng-template
        [ngTemplateOutlet]="delete"
      ></ng-template>
    }
  </div>
}

@if (getCard().type === 'vimeoCard') {
  <div
    [class]="'message-card-vimeo ' + this.getVimeoCard().data.cssClass"
    >
    <iframe
      title="Vimeo video player"
    [src]="('https://player.vimeo.com/video/' + this.getVimeoCard().data.id + '?h=' + this.getVimeoCard().data.hash) | safe"
    frameborder="0"
  ></iframe>
  @if (this.enableDeletion()) {
<ng-template
    [ngTemplateOutlet]="delete"
   
  ></ng-template>
}
</div>
}

@if (getCard().type === 'imageCard') {
  <div
    [class]="'message-card-image ' + this.getImageCard().data.cssClass"
    >
    <img
      class="w-100"
      [src]="this.getImageCard().data.src| safe"
      [alt]="this.getImageCard().data.altText"
      >
    @if (this.enableDeletion()) {
      <ng-template
        [ngTemplateOutlet]="delete"
      ></ng-template>
    }
  </div>
}

@if (getLoadingCard().type === 'loadingCard') {
  <div
    [class]="'message-card-loading ' + this.getLoadingCard().data.cssClass"
    >
    <div class="d-inline loadingCard">
      <div
        class="spinner-grow spinner-grow-sm text-secondary"
        role="status"
        >
        <span class="visually-hidden">Loading...</span>
      </div>
      @if (getLoadingCard().data.icon !== '') {
        <i
          [class]="getLoadingCard().data.icon + ' mx-2'"
        ></i>
      }
      <span [innerHTML]="getLoadingCard().data.text"></span>
    </div>
    @if (this.enableDeletion()) {
      <ng-template
        [ngTemplateOutlet]="delete"
      ></ng-template>
    }
  </div>
}

<ng-template #delete>
  <div class="text-end">
    @if (!this.deleting) {
      <i
        class="ri-close-line text-danger ms-1"
        (click)="deleteMessageAndLoad()"
      ></i>
    }
    @if (this.deleting) {
      <div
        class="spinner-border spinner-border-sm text-danger"
        role="status"
        >
        <span
          class="visually-hidden"
          i18n="@@loading"
        >Loading...</span>
      </div>
    }
  </div>
</ng-template>